import packageJson from '@/package.json';
import { environment } from '@src/environments/environment';
import { init, replayIntegration } from '@sentry/angular';
import { prepareSentryEvent } from '@utils/sentry-error.utils';

// https://develop.sentry.dev/sdk/data-handling/#variable-size
const sentryMaxLengthLimit = 8192;

export function initSentryIfApplicable() {
  if (!!environment.sentry_dsn) {
    init({
      dsn: environment.sentry_dsn,
      sendDefaultPii: environment.sendDefaultPii,
      release: 'release-' + packageJson.version,
      integrations: [
        replayIntegration({
          maskAllText: environment.replaysMaskAllText,
          maskAllInputs: environment.replaysMaskAllInputs,
          blockAllMedia: environment.replaysBlockAllMedia
        })
      ],
      replaysSessionSampleRate: environment.replaysSessionSampleRate,
      replaysOnErrorSampleRate: environment.replaysOnErrorSampleRate,
      maxValueLength: sentryMaxLengthLimit,
      beforeSend(event, hint) {
        return prepareSentryEvent(event, hint);
      }
    });
  }
}
